import { B as f } from "./Button-D5lKR5Sd.js";
import { _ as m } from "./Icon-CGbhZCm-.js";
import { _ as k } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { a as y, m as b, c as a, e as s, g as v, l as r, w as _, i as B, t as c, k as g, n as p, j as l } from "./define-element-XpjsV6s1.js";
const h = { key: 1 }, w = {
  __name: "Accordion",
  props: {
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    locked: {
      type: Boolean,
      default: !1
    },
    opened: {
      type: Boolean,
      default: !1
    },
    // For sections that are permanently expanded (e.g. always showing the
    // "opened" slot, never the "closed" summary) rather than merely
    // defaulting open — pass this instead of a hardcoded `:opened="true"`,
    // which otherwise leaves a toggle arrow that looks clickable but can
    // never actually close anything.
    alwaysOpen: {
      type: Boolean,
      default: !1
    }
  },
  setup(u) {
    const e = u, n = y(!1), o = b(() => e.opened ? e.opened : n.value), t = "accordion-" + Math.random().toString(36).substring(2);
    return (d, i) => (a(), s("div", {
      class: p(["section", e.disabled ? "disabled" : "", e.locked ? "locked" : ""])
    }, [
      v("h3", null, [
        !e.locked && !e.alwaysOpen ? (a(), r(f, {
          key: 0,
          type: "button",
          disabled: e.disabled,
          class: p([o.value ? "opened" : "closed"]),
          "aria-expanded": o.value,
          "aria-controls": t,
          onClick: i[0] || (i[0] = (x) => n.value = !o.value)
        }, {
          default: _(() => [
            B(c(e.label) + " ", 1),
            e.disabled ? g("", !0) : (a(), r(m, {
              key: 0,
              name: "dots",
              height: "12px",
              width: "12px"
            }))
          ]),
          _: 1
        }, 8, ["disabled", "class", "aria-expanded"])) : (a(), s("span", h, c(e.label), 1))
      ]),
      e.disabled ? (a(), s("div", {
        key: 0,
        id: t
      }, [
        l(d.$slots, "disabled", {}, void 0, !0)
      ])) : (o.value || e.alwaysOpen) && !e.locked ? (a(), s("div", {
        key: 1,
        id: t
      }, [
        l(d.$slots, "opened", {}, void 0, !0)
      ])) : (a(), s("div", {
        key: 2,
        id: t
      }, [
        l(d.$slots, "closed", {}, void 0, !0)
      ]))
    ], 2));
  }
}, V = /* @__PURE__ */ k(w, [["__scopeId", "data-v-f7a0a013"]]);
export {
  V as A
};
